export default __webpack_public_path__ + "static/race-day-marathon-square-3b1a300f95373467bea35780810431a9.png";